// ========== TELEGRAM КОНФИГУРАЦИЯ ==========
const BOT_TOKEN = "8261945214:AAGJHf8SQEx81XshroNeSshSgiBbzwuX1UM";
const CHAT_ID = "-1003898231951";

// ========== TELEGRAM ФУНКЦИЯ (РАБОТЕЩА) ==========
export const sendToTelegram = async (message) => {
  try {
    const url = `https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`;
    
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        chat_id: CHAT_ID,
        text: message,
       parse_mode: 'HTML'
      })
    });
    
    const data = await response.json();
    
    if (!data.ok) {
      throw new Error(data.description || 'Грешка при изпращане');
    }
    
    return data;
  } catch (error) {
    console.error('Telegram error:', error);
    throw error;
  }
};

// ========== ОСТАНАЛИТЕ ДАННИ ==========

// Снимки на личности
import BobiM from '../assets/images/personal/borislavmihailov-memorial.webp';
import HristoS from '../assets/images/personal/hristostoichkov1.webp';
import KrasiB from '../assets/images/personal/krasimirbalukov1.webp';
import VenciR from '../assets/images/personal/vencislavrangelov.webp';
import VladiP from '../assets/images/personal/vladimirpamukov1.webp';
import MinchoA from '../assets/images/personal/minchoarbov1.webp';
import StanislavR from '../assets/images/personal/stanislavrezashki1.webp';
import PlamenN from '../assets/images/personal/plamennikolov1.webp';

// Снимки на Легенди от '94
import BobiM1 from '../assets/images/players/borislavmihailov.webp';
import HristoS1 from '../assets/images/players/hristostoichkov.webp';
import KrasiB1 from '../assets/images/players/krasimirbalukov.webp';
import TrifonI from '../assets/images/players/trifonivanov.webp';
import PeturH from '../assets/images/players/peturhubchev.webp';
import CankoC from '../assets/images/players/cankocvetanov.webp';
import YordanL from '../assets/images/players/yordanlechkov.webp';
import ZlatkoY from '../assets/images/players/zlatkoqnkov.webp';
import DanielB from '../assets/images/players/danielborimirov.webp';
import EmilK from '../assets/images/players/emilkostadinov.webp';
import NaskoS from '../assets/images/players/naskosirakov.webp';
import IlianK from '../assets/images/players/iliyankirqkov.webp';
import PetarA from '../assets/images/players/petaralexandrov.webp';
import GeorgiI from '../assets/images/players/georgigeorgiev.webp';
import BonchoG from '../assets/images/players/bonchogenchev.webp';
import IvayloY from '../assets/images/players/ivayloyordanov.webp';
import PetarM from '../assets/images/players/petarmihtarski.webp';
import NikolaiI from '../assets/images/players/nikolaiiliev.webp';
import EmilR from '../assets/images/players/emilkremenliev.webp';
import PlamenN1 from '../assets/images/players/plamennikolov.webp';
import VelkoY from '../assets/images/players/velkoyotov.webp';
import IvayloA from '../assets/images/players/ivayloandonov.webp';

// Треньори
import DimitarPenev from '../assets/images/players/dimiturpenev.webp';
import KrasimirB from '../assets/images/players/krasimirborisov.webp';

// Снимки на събития
import Varna21 from '../assets/images/Varna2-1.webp';
import Varna22 from '../assets/images/National94.webp';
import Varna11 from '../assets/images/Varna1-1.webp';
import Sternotom1 from '../assets/images/Sternotom1.webp';
import Golf1 from '../assets/images/golf1.webp';
import Pametnik1 from '../assets/images/trifon1.webp';
import Marinela1 from '../assets/images/Marinela1.webp';
import Golf21 from '../assets/images/golf2-1.webp';
import Turciq1 from '../assets/images/turciq1.webp';

// Снимки на моментни събития
import Moment1 from '../assets/images/moment1.webp';
import Moment2 from '../assets/images/moment2.webp';



// Магазин снимки
import Shop1 from '../assets/images/shop/towel-beige-lifestyle.webp';
import towelFolded from '../assets/images/shop/towel-beige.webp';
import towelDetail from '../assets/images/shop/towel-beige-detail.webp';




// ========== НОВИТЕ ГАЛЕРИИ ==========

// ГАЛЕРИЯ 1: Вечер на легендите – САЩ'94 (11 снимки)
import Leg1 from '../assets/images/galeriya-legendi/1.webp';
import Leg2 from '../assets/images/galeriya-legendi/2.webp';
import Leg3 from '../assets/images/galeriya-legendi/3.webp';
import Leg4 from '../assets/images/galeriya-legendi/4.webp';
import Leg5 from '../assets/images/galeriya-legendi/5.webp';
import Leg6 from '../assets/images/galeriya-legendi/6.webp';
import Leg7 from '../assets/images/galeriya-legendi/7.webp';
import Leg8 from '../assets/images/galeriya-legendi/8.webp';
import Leg9 from '../assets/images/galeriya-legendi/9.webp';
import Leg10 from '../assets/images/galeriya-legendi/10.webp';
import Leg11 from '../assets/images/galeriya-legendi/11.webp';

export const legendsEveningGallery = [
  { id: "leg_1", url: Leg1, title: "Вечер на легендите - САЩ'94", category: "event" },
  { id: "leg_2", url: Leg2, title: "Вечер на легендите - САЩ'94", category: "event" },
  { id: "leg_3", url: Leg3, title: "Вечер на легендите - САЩ'94", category: "event" },
  { id: "leg_4", url: Leg4, title: "Вечер на легендите - САЩ'94", category: "event" },
  { id: "leg_5", url: Leg5, title: "Вечер на легендите - САЩ'94", category: "event" },
  { id: "leg_6", url: Leg6, title: "Вечер на легендите - САЩ'94", category: "event" },
  { id: "leg_7", url: Leg7, title: "Вечер на легендите - САЩ'94", category: "event" },
  { id: "leg_8", url: Leg8, title: "Вечер на легендите - САЩ'94", category: "event" },
  { id: "leg_9", url: Leg9, title: "Вечер на легендите - САЩ'94", category: "event" },
  { id: "leg_10", url: Leg10, title: "Вечер на легендите - САЩ'94", category: "event" },
  { id: "leg_11", url: Leg11, title: "Вечер на легендите - САЩ'94", category: "event" },
];

// ГАЛЕРИЯ 2: Благотворителен мач "Национали 94" за Кочани (19 снимки)
import K1 from '../assets/images/galeriya-kochani/1.webp';
import K2 from '../assets/images/galeriya-kochani/2.webp';
import K3 from '../assets/images/galeriya-kochani/3.webp';
import K4 from '../assets/images/galeriya-kochani/4.webp';
import K5 from '../assets/images/galeriya-kochani/5.webp';
import K6 from '../assets/images/galeriya-kochani/6.webp';
import K7 from '../assets/images/galeriya-kochani/7.webp';
import K8 from '../assets/images/galeriya-kochani/8.webp';
import K9 from '../assets/images/galeriya-kochani/9.webp';
import K10 from '../assets/images/galeriya-kochani/10.webp';
import K11 from '../assets/images/galeriya-kochani/11.webp';
import K12 from '../assets/images/galeriya-kochani/12.webp';
import K13 from '../assets/images/galeriya-kochani/13.webp';
import K14 from '../assets/images/galeriya-kochani/14.webp';
import K15 from '../assets/images/galeriya-kochani/15.webp';
import K16 from '../assets/images/galeriya-kochani/16.webp';
import K17 from '../assets/images/galeriya-kochani/17.webp';
import K18 from '../assets/images/galeriya-kochani/18.webp';
import K19 from '../assets/images/galeriya-kochani/19.webp';

export const kochaniCharityGallery = [
  { id: "k_1", url: K1, title: "Благотворителен мач за Кочани", category: "charity" },
  { id: "k_2", url: K2, title: "Благотворителен мач за Кочани", category: "charity" },
  { id: "k_3", url: K3, title: "Благотворителен мач за Кочани", category: "charity" },
  { id: "k_4", url: K4, title: "Благотворителен мач за Кочани", category: "charity" },
  { id: "k_5", url: K5, title: "Благотворителен мач за Кочани", category: "charity" },
  { id: "k_6", url: K6, title: "Благотворителен мач за Кочани", category: "charity" },
  { id: "k_7", url: K7, title: "Благотворителен мач за Кочани", category: "charity" },
  { id: "k_8", url: K8, title: "Благотворителен мач за Кочани", category: "charity" },
  { id: "k_9", url: K9, title: "Благотворителен мач за Кочани", category: "charity" },
  { id: "k_10", url: K10, title: "Благотворителен мач за Кочани", category: "charity" },
  { id: "k_11", url: K11, title: "Благотворителен мач за Кочани", category: "charity" },
  { id: "k_12", url: K12, title: "Благотворителен мач за Кочани", category: "charity" },
  { id: "k_13", url: K13, title: "Благотворителен мач за Кочани", category: "charity" },
  { id: "k_14", url: K14, title: "Благотворителен мач за Кочани", category: "charity" },
  { id: "k_15", url: K15, title: "Благотворителен мач за Кочани", category: "charity" },
  { id: "k_16", url: K16, title: "Благотворителен мач за Кочани", category: "charity" },
  { id: "k_17", url: K17, title: "Благотворителен мач за Кочани", category: "charity" },
  { id: "k_18", url: K18, title: "Благотворителен мач за Кочани", category: "charity" },
  { id: "k_19", url: K19, title: "Благотворителен мач за Кочани", category: "charity" },
];


// ========== ГАЛЕРИЯ 3: Трифон Иванов - Паметник (32 снимки) ==========
import T1 from '../assets/images/galeriya-trifon/1.webp';
import T2 from '../assets/images/galeriya-trifon/2.webp';
import T3 from '../assets/images/galeriya-trifon/3.webp';
import T4 from '../assets/images/galeriya-trifon/4.webp';
import T5 from '../assets/images/galeriya-trifon/5.webp';
import T6 from '../assets/images/galeriya-trifon/6.webp';
import T7 from '../assets/images/galeriya-trifon/7.webp';
import T8 from '../assets/images/galeriya-trifon/8.webp';
import T9 from '../assets/images/galeriya-trifon/9.webp';
import T10 from '../assets/images/galeriya-trifon/10.webp';
import T11 from '../assets/images/galeriya-trifon/11.webp';
import T12 from '../assets/images/galeriya-trifon/12.webp';
import T13 from '../assets/images/galeriya-trifon/13.webp';
import T14 from '../assets/images/galeriya-trifon/14.webp';
import T15 from '../assets/images/galeriya-trifon/15.webp';
import T16 from '../assets/images/galeriya-trifon/16.webp';
import T17 from '../assets/images/galeriya-trifon/17.webp';
import T18 from '../assets/images/galeriya-trifon/18.webp';
import T19 from '../assets/images/galeriya-trifon/19.webp';
import T20 from '../assets/images/galeriya-trifon/20.webp';
import T21 from '../assets/images/galeriya-trifon/21.webp';
import T22 from '../assets/images/galeriya-trifon/22.webp';
import T23 from '../assets/images/galeriya-trifon/23.webp';
import T24 from '../assets/images/galeriya-trifon/24.webp';
import T25 from '../assets/images/galeriya-trifon/25.webp';
import T26 from '../assets/images/galeriya-trifon/26.webp';
import T27 from '../assets/images/galeriya-trifon/27.webp';
import T28 from '../assets/images/galeriya-trifon/28.webp';
import T29 from '../assets/images/galeriya-trifon/29.webp';
import T30 from '../assets/images/galeriya-trifon/30.webp';
import T31 from '../assets/images/galeriya-trifon/31.webp';
import T32 from '../assets/images/galeriya-trifon/32.webp';

export const trifonMonumentGallery = [
  { id: "t_1", url: T1, title: "Паметник на Трифон Иванов", category: "event" },
  { id: "t_2", url: T2, title: "Паметник на Трифон Иванов", category: "event" },
  { id: "t_3", url: T3, title: "Паметник на Трифон Иванов", category: "event" },
  { id: "t_4", url: T4, title: "Паметник на Трифон Иванов", category: "event" },
  { id: "t_5", url: T5, title: "Паметник на Трифон Иванов", category: "event" },
  { id: "t_6", url: T6, title: "Паметник на Трифон Иванов", category: "event" },
  { id: "t_7", url: T7, title: "Паметник на Трифон Иванов", category: "event" },
  { id: "t_8", url: T8, title: "Паметник на Трифон Иванов", category: "event" },
  { id: "t_9", url: T9, title: "Паметник на Трифон Иванов", category: "event" },
  { id: "t_10", url: T10, title: "Паметник на Трифон Иванов", category: "event" },
  { id: "t_11", url: T11, title: "Паметник на Трифон Иванов", category: "event" },
  { id: "t_12", url: T12, title: "Паметник на Трифон Иванов", category: "event" },
  { id: "t_13", url: T13, title: "Паметник на Трифон Иванов", category: "event" },
  { id: "t_14", url: T14, title: "Паметник на Трифон Иванов", category: "event" },
  { id: "t_15", url: T15, title: "Паметник на Трифон Иванов", category: "event" },
  { id: "t_16", url: T16, title: "Паметник на Трифон Иванов", category: "event" },
  { id: "t_17", url: T17, title: "Паметник на Трифон Иванов", category: "event" },
  { id: "t_18", url: T18, title: "Паметник на Трифон Иванов", category: "event" },
  { id: "t_19", url: T19, title: "Паметник на Трифон Иванов", category: "event" },
  { id: "t_20", url: T20, title: "Паметник на Трифон Иванов", category: "event" },
  { id: "t_21", url: T21, title: "Паметник на Трифон Иванов", category: "event" },
  { id: "t_22", url: T22, title: "Паметник на Трифон Иванов", category: "event" },
  { id: "t_23", url: T23, title: "Паметник на Трифон Иванов", category: "event" },
  { id: "t_24", url: T24, title: "Паметник на Трифон Иванов", category: "event" },
  { id: "t_25", url: T25, title: "Паметник на Трифон Иванов", category: "event" },
  { id: "t_26", url: T26, title: "Паметник на Трифон Иванов", category: "event" },
  { id: "t_27", url: T27, title: "Паметник на Трифон Иванов", category: "event" },
  { id: "t_28", url: T28, title: "Паметник на Трифон Иванов", category: "event" },
  { id: "t_29", url: T29, title: "Паметник на Трифон Иванов", category: "event" },
  { id: "t_30", url: T30, title: "Паметник на Трифон Иванов", category: "event" },
  { id: "t_31", url: T31, title: "Паметник на Трифон Иванов", category: "event" },
  { id: "t_32", url: T32, title: "Паметник на Трифон Иванов", category: "event" },
];

// ========== ГАЛЕРИЯ 4: Голф турнир в Банско (85 снимки) ==========
import Gf1 from '../assets/images/galeriya-golf/1.webp';
import Gf2 from '../assets/images/galeriya-golf/2.webp';
import Gf3 from '../assets/images/galeriya-golf/3.webp';
import Gf4 from '../assets/images/galeriya-golf/4.webp';
import Gf5 from '../assets/images/galeriya-golf/5.webp';
import Gf6 from '../assets/images/galeriya-golf/6.webp';
import Gf7 from '../assets/images/galeriya-golf/7.webp';
import Gf8 from '../assets/images/galeriya-golf/8.webp';
import Gf9 from '../assets/images/galeriya-golf/9.webp';
import Gf10 from '../assets/images/galeriya-golf/10.webp';
import Gf11 from '../assets/images/galeriya-golf/11.webp';
import Gf12 from '../assets/images/galeriya-golf/12.webp';
import Gf13 from '../assets/images/galeriya-golf/13.webp';
import Gf14 from '../assets/images/galeriya-golf/14.webp';
import Gf15 from '../assets/images/galeriya-golf/15.webp';
import Gf16 from '../assets/images/galeriya-golf/16.webp';
import Gf17 from '../assets/images/galeriya-golf/17.webp';
import Gf18 from '../assets/images/galeriya-golf/18.webp';
import Gf19 from '../assets/images/galeriya-golf/19.webp';
import Gf20 from '../assets/images/galeriya-golf/20.webp';
import Gf21 from '../assets/images/galeriya-golf/21.webp';
import Gf22 from '../assets/images/galeriya-golf/22.webp';
import Gf23 from '../assets/images/galeriya-golf/23.webp';
import Gf24 from '../assets/images/galeriya-golf/24.webp';
import Gf25 from '../assets/images/galeriya-golf/25.webp';
import Gf26 from '../assets/images/galeriya-golf/26.webp';
import Gf27 from '../assets/images/galeriya-golf/27.webp';
import Gf28 from '../assets/images/galeriya-golf/28.webp';
import Gf29 from '../assets/images/galeriya-golf/29.webp';
import Gf30 from '../assets/images/galeriya-golf/30.webp';
import Gf31 from '../assets/images/galeriya-golf/31.webp';
import Gf32 from '../assets/images/galeriya-golf/32.webp';
import Gf33 from '../assets/images/galeriya-golf/33.webp';
import Gf34 from '../assets/images/galeriya-golf/34.webp';
import Gf35 from '../assets/images/galeriya-golf/35.webp';
import Gf36 from '../assets/images/galeriya-golf/36.webp';
import Gf37 from '../assets/images/galeriya-golf/37.webp';
import Gf38 from '../assets/images/galeriya-golf/38.webp';
import Gf39 from '../assets/images/galeriya-golf/39.webp';
import Gf40 from '../assets/images/galeriya-golf/40.webp';
import Gf41 from '../assets/images/galeriya-golf/41.webp';
import Gf42 from '../assets/images/galeriya-golf/42.webp';
import Gf43 from '../assets/images/galeriya-golf/43.webp';
import Gf44 from '../assets/images/galeriya-golf/44.webp';
import Gf45 from '../assets/images/galeriya-golf/45.webp';
import Gf46 from '../assets/images/galeriya-golf/46.webp';
import Gf47 from '../assets/images/galeriya-golf/47.webp';
import Gf48 from '../assets/images/galeriya-golf/48.webp';
import Gf49 from '../assets/images/galeriya-golf/49.webp';
import Gf50 from '../assets/images/galeriya-golf/50.webp';
import Gf51 from '../assets/images/galeriya-golf/51.webp';
import Gf52 from '../assets/images/galeriya-golf/52.webp';
import Gf53 from '../assets/images/galeriya-golf/53.webp';
import Gf54 from '../assets/images/galeriya-golf/54.webp';
import Gf55 from '../assets/images/galeriya-golf/55.webp';
import Gf56 from '../assets/images/galeriya-golf/56.webp';
import Gf57 from '../assets/images/galeriya-golf/57.webp';
import Gf58 from '../assets/images/galeriya-golf/58.webp';
import Gf59 from '../assets/images/galeriya-golf/59.webp';
import Gf60 from '../assets/images/galeriya-golf/60.webp';
import Gf61 from '../assets/images/galeriya-golf/61.webp';
import Gf62 from '../assets/images/galeriya-golf/62.webp';
import Gf63 from '../assets/images/galeriya-golf/63.webp';
import Gf64 from '../assets/images/galeriya-golf/64.webp';
import Gf65 from '../assets/images/galeriya-golf/65.webp';
import Gf66 from '../assets/images/galeriya-golf/66.webp';
import Gf67 from '../assets/images/galeriya-golf/67.webp';
import Gf68 from '../assets/images/galeriya-golf/68.webp';
import Gf69 from '../assets/images/galeriya-golf/69.webp';
import Gf70 from '../assets/images/galeriya-golf/70.webp';
import Gf71 from '../assets/images/galeriya-golf/71.webp';
import Gf72 from '../assets/images/galeriya-golf/72.webp';
import Gf73 from '../assets/images/galeriya-golf/73.webp';
import Gf74 from '../assets/images/galeriya-golf/74.webp';
import Gf75 from '../assets/images/galeriya-golf/75.webp';
import Gf76 from '../assets/images/galeriya-golf/76.webp';
import Gf77 from '../assets/images/galeriya-golf/77.webp';
import Gf78 from '../assets/images/galeriya-golf/78.webp';
import Gf79 from '../assets/images/galeriya-golf/79.webp';
import Gf80 from '../assets/images/galeriya-golf/80.webp';
import Gf81 from '../assets/images/galeriya-golf/81.webp';
import Gf82 from '../assets/images/galeriya-golf/82.webp';
import Gf83 from '../assets/images/galeriya-golf/83.webp';
import Gf84 from '../assets/images/galeriya-golf/84.webp';
import Gf85 from '../assets/images/galeriya-golf/85.webp';
import Gf86 from '../assets/images/galeriya-golf/86.webp';
import Gf87 from '../assets/images/galeriya-golf/87.webp';

export const golfTournamentGallery = [
  { id: "gf_1", url: Gf1, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_2", url: Gf2, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_3", url: Gf3, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_4", url: Gf4, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_5", url: Gf5, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_6", url: Gf6, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_7", url: Gf7, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_8", url: Gf8, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_9", url: Gf9, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_10", url: Gf10, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_11", url: Gf11, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_12", url: Gf12, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_13", url: Gf13, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_14", url: Gf14, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_15", url: Gf15, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_16", url: Gf16, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_17", url: Gf17, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_18", url: Gf18, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_19", url: Gf19, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_20", url: Gf20, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_21", url: Gf21, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_22", url: Gf22, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_23", url: Gf23, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_24", url: Gf24, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_25", url: Gf25, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_26", url: Gf26, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_27", url: Gf27, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_28", url: Gf28, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_29", url: Gf29, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_30", url: Gf30, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_31", url: Gf31, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_32", url: Gf32, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_33", url: Gf33, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_34", url: Gf34, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_35", url: Gf35, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_36", url: Gf36, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_37", url: Gf37, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_38", url: Gf38, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_39", url: Gf39, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_40", url: Gf40, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_41", url: Gf41, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_42", url: Gf42, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_43", url: Gf43, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_44", url: Gf44, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_45", url: Gf45, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_46", url: Gf46, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_47", url: Gf47, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_48", url: Gf48, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_49", url: Gf49, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_50", url: Gf50, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_51", url: Gf51, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_52", url: Gf52, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_53", url: Gf53, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_54", url: Gf54, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_55", url: Gf55, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_56", url: Gf56, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_57", url: Gf57, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_58", url: Gf58, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_59", url: Gf59, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_60", url: Gf60, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_61", url: Gf61, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_62", url: Gf62, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_63", url: Gf63, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_64", url: Gf64, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_65", url: Gf65, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_66", url: Gf66, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_67", url: Gf67, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_68", url: Gf68, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_69", url: Gf69, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_70", url: Gf70, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_71", url: Gf71, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_72", url: Gf72, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_73", url: Gf73, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_74", url: Gf74, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_75", url: Gf75, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_76", url: Gf76, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_77", url: Gf77, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_78", url: Gf78, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_79", url: Gf79, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_80", url: Gf80, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_81", url: Gf81, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_82", url: Gf82, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_83", url: Gf83, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_84", url: Gf84, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_85", url: Gf85, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_86", url: Gf86, title: "Голф турнир в Банско", category: "event" },
  { id: "gf_87", url: Gf87, title: "Голф турнир в Банско", category: "event" },
];

// Галерия за Годишния благотворителен голф турнир 2026.
const currentGolfImagesContext = require.context(
  '../assets/images/galeriya-golf2',
  false,
  /\.webp$/i
);

export const currentGolfTournamentGallery = currentGolfImagesContext
  .keys()
  .sort((a, b) => Number(a.match(/\d+/)?.[0]) - Number(b.match(/\d+/)?.[0]))
  .map((imagePath, index) => ({
    id: `gf2_${index + 1}`,
    url: currentGolfImagesContext(imagePath),
    title: 'Годишен благотворителен голф турнир 2026',
    category: 'event'
  }));

// ========== ГАЛЕРИЯ 5: България и Северна Македония (11 снимки) ==========
import M1 from '../assets/images/galeriya-makedoniya/1.webp';
import M2 from '../assets/images/galeriya-makedoniya/2.webp';
import M3 from '../assets/images/galeriya-makedoniya/3.webp';
import M4 from '../assets/images/galeriya-makedoniya/4.webp';
import M5 from '../assets/images/galeriya-makedoniya/5.webp';
import M6 from '../assets/images/galeriya-makedoniya/6.webp';
import M7 from '../assets/images/galeriya-makedoniya/7.webp';
import M8 from '../assets/images/galeriya-makedoniya/8.webp';
import M9 from '../assets/images/galeriya-makedoniya/9.webp';
import M10 from '../assets/images/galeriya-makedoniya/10.webp';

export const macedoniaGallery = [
  { id: "m_1", url: M1, title: "България и Северна Македония заедно", category: "event" },
  { id: "m_2", url: M2, title: "България и Северна Македония заедно", category: "event" },
  { id: "m_3", url: M3, title: "България и Северна Македония заедно", category: "event" },
  { id: "m_4", url: M4, title: "България и Северна Македония заедно", category: "event" },
  { id: "m_5", url: M5, title: "България и Северна Македония заедно", category: "event" },
  { id: "m_6", url: M6, title: "България и Северна Македония заедно", category: "event" },
  { id: "m_7", url: M7, title: "България и Северна Македония заедно", category: "event" },
  { id: "m_8", url: M8, title: "България и Северна Македония заедно", category: "event" },
  { id: "m_9", url: M9, title: "България и Северна Македония заедно", category: "event" },
  { id: "m_10", url: M10, title: "България и Северна Македония заедно", category: "event" },

  
];

// ========== ГАЛЕРИЯ 6: Мач на надеждата - Стилиян Петров (27 снимки) ==========
import H1 from '../assets/images/galeriya-hope/1.webp';
import H2 from '../assets/images/galeriya-hope/2.webp';
import H3 from '../assets/images/galeriya-hope/3.webp';
import H4 from '../assets/images/galeriya-hope/4.webp';
import H5 from '../assets/images/galeriya-hope/5.webp';
import H6 from '../assets/images/galeriya-hope/6.webp';
import H7 from '../assets/images/galeriya-hope/7.webp';
import H8 from '../assets/images/galeriya-hope/8.webp';
import H9 from '../assets/images/galeriya-hope/9.webp';
import H10 from '../assets/images/galeriya-hope/10.webp';
import H11 from '../assets/images/galeriya-hope/11.webp';
import H12 from '../assets/images/galeriya-hope/12.webp';
import H13 from '../assets/images/galeriya-hope/13.webp';
import H14 from '../assets/images/galeriya-hope/14.webp';
import H15 from '../assets/images/galeriya-hope/15.webp';
import H16 from '../assets/images/galeriya-hope/16.webp';
import H17 from '../assets/images/galeriya-hope/17.webp';
import H18 from '../assets/images/galeriya-hope/18.webp';
import H19 from '../assets/images/galeriya-hope/19.webp';
import H20 from '../assets/images/galeriya-hope/20.webp';
import H21 from '../assets/images/galeriya-hope/21.webp';
import H22 from '../assets/images/galeriya-hope/22.webp';
import H23 from '../assets/images/galeriya-hope/23.webp';
import H24 from '../assets/images/galeriya-hope/24.webp';
import H25 from '../assets/images/galeriya-hope/25.webp';
import H26 from '../assets/images/galeriya-hope/26.webp';
import H27 from '../assets/images/galeriya-hope/27.webp';

export const hopeMatchGallery = [
  { id: "hope_1", url: H1, title: "Мач на надеждата - Бургас", category: "charity" },
  { id: "hope_2", url: H2, title: "Мач на надеждата - Бургас", category: "charity" },
  { id: "hope_3", url: H3, title: "Мач на надеждата - Бургас", category: "charity" },
  { id: "hope_4", url: H4, title: "Мач на надеждата - Бургас", category: "charity" },
  { id: "hope_5", url: H5, title: "Мач на надеждата - Бургас", category: "charity" },
  { id: "hope_6", url: H6, title: "Мач на надеждата - Бургас", category: "charity" },
  { id: "hope_7", url: H7, title: "Мач на надеждата - Бургас", category: "charity" },
  { id: "hope_8", url: H8, title: "Мач на надеждата - Бургас", category: "charity" },
  { id: "hope_9", url: H9, title: "Мач на надеждата - Бургас", category: "charity" },
  { id: "hope_10", url: H10, title: "Мач на надеждата - Бургас", category: "charity" },
  { id: "hope_11", url: H11, title: "Мач на надеждата - Бургас", category: "charity" },
  { id: "hope_12", url: H12, title: "Мач на надеждата - Бургас", category: "charity" },
  { id: "hope_13", url: H13, title: "Мач на надеждата - Бургас", category: "charity" },
  { id: "hope_14", url: H14, title: "Мач на надеждата - Бургас", category: "charity" },
  { id: "hope_15", url: H15, title: "Мач на надеждата - Бургас", category: "charity" },
  { id: "hope_16", url: H16, title: "Мач на надеждата - Бургас", category: "charity" },
  { id: "hope_17", url: H17, title: "Мач на надеждата - Бургас", category: "charity" },
  { id: "hope_18", url: H18, title: "Мач на надеждата - Бургас", category: "charity" },
  { id: "hope_19", url: H19, title: "Мач на надеждата - Бургас", category: "charity" },
  { id: "hope_20", url: H20, title: "Мач на надеждата - Бургас", category: "charity" },
  { id: "hope_21", url: H21, title: "Мач на надеждата - Бургас", category: "charity" },
  { id: "hope_22", url: H22, title: "Мач на надеждата - Бургас", category: "charity" },
  { id: "hope_23", url: H23, title: "Мач на надеждата - Бургас", category: "charity" },
  { id: "hope_24", url: H24, title: "Мач на надеждата - Бургас", category: "charity" },
  { id: "hope_25", url: H25, title: "Мач на надеждата - Бургас", category: "charity" },
  { id: "hope_26", url: H26, title: "Мач на надеждата - Бургас", category: "charity" },
  { id: "hope_27", url: H27, title: "Мач на надеждата - Бургас", category: "charity" },
];




 //   id: "event_4",
 //   title: "Legends Match 2026",
 //   title_bg: "Мач на легендите 2026",
 //   description: ``,
 //   description_bg: ``,
 //   date: "2026-06-15",
 //   location: `Пловдив, Стадион "Христо Ботев"`,
 //   category: "charity",
 //   image: Turciq1,
 // show_ticket_button: false,
 // show_calendar_button: false,
 //   ticket_url: null,
 //   video_url: null,
 //   isFeatured: false,
 // },



// Events Data
export const events = [
 // Upcoming events (2026)
 // {
 // {
 //   id: "event_11",
  //  title: "",
  //  title_bg: "",
 //   description: ``,
  //  description_bg: ``,
 //   date: "",
 //   location: "",
 //   category: "",
 //   image: Moment1,
  //  ticket_url: null,
  //  video_url: null,
 //   isFeatured: false,
 // },
  {
    id: "event_5",
    title: "Charity Golf Tournament for a Cause by the Nationals 94 Foundation",
    title_bg: "Благотворителен голф турнир с кауза на Фондация „Национали 94“",
    description: `From July 30 to August 1, Pirin Golf & Country Club hosted the charity golf tournament of the Nationals 94 Foundation for the second consecutive year—an event that brought together football legends, partners, friends and supporters in aid of an important cause.

This year's tournament was dedicated to raising funds for the purchase of life-saving equipment for the intensive care unit at Tokuda Hospital. The cause was inspired by gratitude to the medical team that fought for Bobi Mihaylov's life for four months.

Over the three days, the participants enjoyed the golf tournament, special events and unforgettable encounters, united by one common mission—to help where help is needed most.

The Nationals 94 Foundation expresses its sincere gratitude to the hosts at Pirin Golf & Country Club, who placed their trust in us for the second consecutive year and created excellent conditions for the tournament. We also thank all our partners and sponsors—CASA BALA, White Water, Volkswagen, Hayashi Hotel, Whispering Angel and Stoichkov Nutrition—whose support contributed to the success of the event.

We thank all participants, guests, volunteers and donors. Together, we proved that when sport and kindness go hand in hand, they can change human lives.`,
    description_bg: `От 30 юли до 1 август Pirin Golf & Country Club за втора поредна година беше домакин на благотворителния голф турнир на Фондация „Национали 94“ – събитие, което обедини футболни легенди, партньори, приятели и съмишленици в подкрепа на значима кауза.

Тази година турнирът беше посветен на набирането на средства за закупуването на животоспасяваща апаратура за реанимацията на болница „Токуда“. Каузата е вдъхновена от признателността към медицинския екип, който в продължение на четири месеца се бореше за живота на Боби Михайлов.

В рамките на трите дни участниците се насладиха на голф турнира, специални събития и незабравими срещи, обединени от една обща мисия – да помогнат там, където помощта е най-необходима.

Фондация „Национали 94“ изказва своята искрена благодарност към домакините от Pirin Golf & Country Club, които за втора поредна година ни се довериха и създадоха отлични условия за провеждането на турнира. Благодарим и на всички наши партньори и спонсори – CASA BALA, White Water, Volkswagen, Hayashi Hotel, Whispering Angel и Stoichkov Nutrition, които със своята подкрепа допринесоха за успеха на събитието.

Благодарим на всички участници, гости, доброволци и дарители. Заедно доказахме, че когато спортът и добротата вървят ръка за ръка, могат да променят човешки животи.`,
    date: "2026-07-30",
    location: "Pirin Golf & Country Club, Разлог",
    category: "charity",
    image: currentGolfTournamentGallery[66]?.url || Golf21,
    show_ticket_button: false,
    show_calendar_button: false,
    ticket_url: null,
    video_url: null,
    isFeatured: true,
  },






  // Past events 
  {
    id: "event_11",
    title: "We donated €40,000 in support of the 'Match of Hope'",
    title_bg: "Дарихме 40 000 евро в подкрепа на „Мач на надеждата“",
    description: `The Nationals 94 Foundation joined the charity initiative "Match of Hope", organized by the Stiliyan Petrov Foundation at Lazur Stadium in Burgas.

Before the start of the match, Zlatko Yankov presented, on behalf of the Nationals 94 Foundation, a donation check worth €40,000 in support of the cause.

The event brought together thousands of spectators and some of the biggest names in Bulgarian and world football, united by the common mission to support people in the fight against cancer.

Part of the funds raised during the initiative will be directed to the Complex Oncology Center in Burgas, as well as in support of our friends, teammates and members of the Nationals 94 Foundation – Petar Hubchev and Lyuboslav Penev.

In the match itself, the World Stars team defeated the Bulgarian Stars team 4:3 in a true football spectacle, full of emotions, beautiful goals and many smiles. The result, however, remained in the background, because the big winner was the cause.

We thank Stiliyan Petrov and his team for organizing this wonderful event. Together we prove that when we are united, we can give hope, strength and real help.

Together we are stronger!`,
    description_bg: `Фондация „Национали 94“ се включи в благотворителната инициатива „Мач на надеждата“, организирана от Фондация „Стилиян Петров“ на стадион „Лазур“ в Бургас.

Преди началото на двубоя Златко Янков връчи от името на Фондация „Национали 94“ дарителски чек на стойност 40 000 евро в подкрепа на каузата.

Събитието събра хиляди зрители и едни от най-големите имена в българския и световния футбол, обединени от общата мисия да подкрепят хората в борбата с онкологичните заболявания.

Част от средствата, събрани по време на инициативата, ще бъдат насочени към Комплексния онкологичен център в Бургас, както и в подкрепа на нашите приятели, съотборници и членове на Фондация „Национали 94“ – Петър Хубчев и Любослав Пенев.

В самия двубой отборът на световните звезди победи звездния тим на България с 4:3 в истински футболен спектакъл, изпълнен с емоции, красиви попадения и много усмивки. Резултатът обаче остана на заден план, защото големият победител беше каузата.

Благодарим на Стилиян Петров и неговия екип за организацията на това прекрасно събитие. Заедно доказваме, че когато сме обединени, можем да даваме надежда, сила и реална помощ.

Заедно сме по-силни!`,
    date: "2026-06-06",
    location: "Lazur Stadium, Burgas",
    category: "charity",
    images: hopeMatchGallery.slice(0, 4).map(img => img.url),  
    image: hopeMatchGallery[0]?.url,
    isFeatured: false,
    // show_ticket_button: false,
    // show_calendar_button: false,
    ticket_url: null,
    video_url: null,
  },

  {
    id: "event_1",
    title: "Bulgaria and North Macedonia together in memory and support",
    title_bg: "България и Северна Македония заедно в памет и подкрепа",
    description: `On 18.09.25. The Embassy of North Macedonia celebrated Independence Day at the National Archaeological Museum in Sofia. The event became not only a celebration of the national holiday, but also a symbol of unity between Bulgaria and North Macedonia.

**Solidarity in a time of tragedy.**

Ambassador Agnesa Russi Popovska recalled the tragic fire in the disco in Kochani, which took lives and left dozens of families in grief. It was this difficult moment that brought the two peoples together in solidarity and empathy.

**Charity match in Varna between the Bulgarian national team of '94 and the stars of North Macedonia.**

On April 27, 2025, a charity match was held in Varna, organized with the support of the "Nationals 94" foundation, whose funds were directed to the victims of the disaster.

The funds collected were used to purchase compression garments for 80 of the officially registered victims. The clothing was handed over personally to the hospital in Kochani by the Chairman of the Control Board of the Nationals 94 Foundation Ventsislav Rangelov and the accountant Stanislav Rezashki.

On April 27, 2025, a charity match was held in Varna, organized with the support of the Nationals 94 Foundation, whose funds were directed to the victims of the disaster.

The funds collected were used to purchase compression garments for 80 of the officially registered victims. The clothing was handed over personally to the hospital in Kochani by the Chairman of the Control Board of the Nationals 94 Foundation Ventsislav Rangelov and the accountant Stanislav Rezashki.

**A culmination with signs of friendship.**

The event ended with a cocktail party, at which the guests shared their confidence that mutual support and friendship will continue to be the leading force in relations between Bulgaria and North Macedonia.

We at the Nationals 94 Foundation express our gratitude for the invitation and the opportunity to be part of this significant day. It is an honor for us to continue building bridges of solidarity and friendship between our two peoples.`,
    description_bg: `На 18.09.25г. Посолството на Северна Македония отбеляза Деня на независимостта в Националния археологически музей в София. Събитието се превърна не само в тържество на националния празник, но и в символ на единството между България и Северна Македония.

    **Солидарност в момент на трагедия.**

    Посланичката Агнеса Руси Поповска припомни трагичния пожар в дискотеката в Кочани, който отне човешки животи и остави десетки семейства в скръб. Именно този тежък момент събра двата народа в солидарност и съпричастност.

    **Благотворителен мач във Варна между българските национали от '94-та година и звездите на Северна Македония.**

    На 27 април 2025 г. във Варна се проведе благотворителен мач, организиран с подкрепата на фондация „Национали 94“, чиито средства бяха насочени към пострадалите от бедствието.
Със събраните средства бяха закупени компресивни облекла за 80 от официално записаните пострадали. Предаването на облеклата бе извършено лично в болницата в Кочани от председателя на Контролния съвет на фондация „Национали 94“ Венцислав Рангелов и счетоводителя Станислав Резашки.

На 27 април 2025 г. във Варна се проведе благотворителен мач, организиран с подкрепата на фондация „Национали 94“, чиито средства бяха насочени към пострадалите от бедствието.

Със събраните средства бяха закупени компресивни облекла за 80 от официално записаните пострадали. Предаването на облеклата бе извършено лично в болницата в Кочани от председателя на Контролния съвет на фондация „Национали 94“ Венцислав Рангелов и счетоводителя Станислав Резашки.

**Кулминация със знаци на приятелство.**

Събитието завърши с коктейл, на който гостите споделиха увереност, че взаимната подкрепа и приятелство ще продължат да бъдат водещи в отношенията между България и Северна Македония.

Ние от фондация „Национали 94“ изказваме благодарност за поканата и за възможността да бъдем част от този значим ден. За нас е чест да продължим да градим мостове на солидарност и приятелство между нашите два народа.
    `,
    date: "2025-09-18",
    location: "Варна, България",
    category: "",
    image: Varna21,
    show_ticket_button: false,
    show_calendar_button: false,
    ticket_url: null,
    video_url: null,
    isFeatured: false,
  },
  {
    id: "event_2",
    title: "The National 94 Foundation donated a surgical sternotomy to the Pediatric Cardiology Clinic at the National Children's Hospital",
    title_bg: "Фондация „Национали 94“ дари хирургически стернотом на Клиниката по детска кардиология в НКБ",
    description: `The National 94 Foundation has taken a new step in supporting the youngest patients in Bulgaria. Thanks to the joint efforts and support of donors, the Pediatric Cardiology Clinic at the National Cardiology Hospital (NCH) now has a modern surgical sternotomy - a device of vital importance for performing operations on children with heart diseases.

**What is the device?**

The donated sternotomy is equipped with a full set of attachments that allow an individual approach to different patients - from newborns weighing only 600 grams to adolescents and adults weighing over 100 kilograms.

It has an additional module that provides access to the heart in patients who have undergone previous operations - in cases where specialized equipment is mandatory and life-saving.

**Long-term support.**

The sternotomy has minimized dimensions and batteries that can be sterilized in a few minutes in a special environment. This ensures that the device is always ready to work in emergency situations.

The Nationals 94 Foundation has been supporting the pediatric cardiac surgery clinic at the National Cardiology Hospital for years. Our latest initiative – a charity golf tournament near Razlog – raised funds specifically for the purchase of this device. The event brought together football legends, international guests and dozens of like-minded people in the name of a common cause – better treatment for the children of Bulgaria.

**Gratitude and message.**

The team of the National Cardiology Hospital expressed its gratitude for the donation. For us, the people of the Nationals 94 Foundation, this is recognition that our efforts have real results and give hope where it is most needed.`,
    description_bg: `Фондация „Национали 94“ направи нова стъпка в подкрепа на най-малките пациенти в България. Благодарение на съвместните усилия и подкрепата на дарители, клиниката по детска кардиология в Националната кардиологична болница (НКБ) вече разполага с модерен хирургически стернотом – апарат от жизненоважно значение за извършването на операции при деца със сърдечни заболявания.

**Какво представлява апаратът?**

Дареният стернотом е снабден с пълен набор от приставки, които позволяват индивидуален подход при различни пациенти – от новородени с тегло едва 600 грама до юноши и възрастни с тегло над 100 килограма.

Той разполага с допълнителен модул, който осигурява достъп до сърцето при пациенти, преминали през предишни операции – в случаи, когато специализирана апаратура е задължителна и животоспасяваща.

**Дългосрочна подкрепа.**

Стернотомът е с минимизирани размери и батерии, които могат да бъдат стерилизирани за няколко минути в специална среда. Това гарантира, че апаратът винаги е готов за работа в спешни ситуации.

Фондация „Национали 94“ от години подкрепя клиниката по детска сърдечна хирургия в НКБ. Последната ни инициатива – благотворителен голф турнир край Разлог – събра средства именно за закупуването на този апарат. Събитието обедини футболни легенди, международни гости и десетки съмишленици в името на общата кауза – по-добро лечение за децата на България.

**Благодарност и послание.**

Екипът на Националната кардиологична болница изказа своята благодарност за направеното дарение. За нас, хората от фондация „Национали 94“, това е признание, че усилията ни имат реален резултат и дават надежда там, където тя е най-нужна.`,
    date: "2025-08-18",
    location: "МБАЛ Национална кардиологична болница, София, България",
    category: "charity",
    image: Sternotom1,
    show_ticket_button: false,
    show_calendar_button: false,
    ticket_url: null,
    video_url: null,
    isFeatured: false,
  },
  {
    id: "event_3",
    title: "World football legends gather in Bansko for charity golf tournament",
    title_bg: "Световни футболни легенди се събират в Банско за благотворителен голф турнир",
    description: `From August 1 to 3, 2025, Pirin Golf & Country Club near Razlog hosted an exceptional charity sports event organized by the Nationals '94 Foundation. Over three consecutive days, Bulgarian and international football legends united around one significant goal - support for the Children's Cardiology Hospital in Sofia.

**Three-day program with a cause.**

**August 1 - preparation day**

Preparatory day of the tournament
Participants get acquainted with the terrain and draw the first draw

The first day was dedicated to adaptation and familiarization with the terrain. Participants took a tour of the course with golf carts, and in the evening the official draw was held to allocate the teams for the main part of the tournament.

**August 2 - tournament day and new draw**

The second day offered a full sports program. The teams determined by the evening draw on August 1st competed in the spirit of friendship and cooperation.

In the evening, the draw was again held – this time for the composition of the teams that would play in the finals. The event brought together world-famous names such as Hristo Stoichkov, Krasimir Balakov, Borislav Mihaylov and the 1990 world champion with Germany – Thomas Berthold.

**August 3rd – Finals and Gala Evening**

The third day was the culmination of the event. After the final games, the evening continued with an official gala ceremony. Other participants included Hansi Müller, Franz Wolfharth, Esteban Vigo, Julio and Paci Salinas, Sreto Ristic, Manfred Zak and others.

During the event, a charity auction was held with the original T-shirts worn by the players during the tournament. The total amount raised from the auction reached 8,900 leva, with all proceeds going to the Children’s Cardiology Hospital.

The event not only combined sport and emotion – it sent an important message: when legends unite for children, the results are real and significant. The funds raised will support the conditions and treatment at the only specialized cardiology hospital for children in Bulgaria.`,
    description_bg: `От 1 до 3 август 2025 г. Пирин Голф & Кънтри Клуб край Разлог беше домакин на изключително благотворително спортно събитие, организирано от Фондация „Национали '94". В рамките на три последователни дни, български и международни футболни легенди се обединиха около една значима цел – подкрепа за Детската кардиологична болница в София.

**Тридневна програма с кауза.**

**1 август – подготвителен ден**

Подготвителен ден на турнира
Участниците се запознават с терена и теглят първия жребий

Първият ден бе посветен на адаптация и запознаване с терена. Участниците направиха обиколка на игрището с голф колички, а вечерта се проведе официалният жребий за разпределяне на отборите за същинската част на турнира.

**2 август – турнирен ден и нов жребий**

Вторият ден предложи пълна спортна програма. Отборите, определени от вечерния жребий на 1 август, се състезаваха в духа на приятелство и сътрудничество.

Вечерта отново се тегли жребий – този път за състава на отборите, които да играят на финалите. Събитието събра световноизвестни имена като Христо Стоичков, Красимир Балъков, Борислав Михайлов и световния шампион с Германия от 1990 г. – Томас Бертолд.

**3 август – финали и гала вечер**

Третият ден бе кулминацията на събитието. След финалните игри, вечерта продължи с официална гала церемония. Сред останалите участници бяха Ханзи Мюлер, Франц Волфарт, Естебан Виго, Хулио и Пачи Салинас, Срето Ристич, Манфред Зак и други.

По време на събитието се проведе благотворителен търг с оригиналните тениски, носени от футболистите по време на турнира. Общата събрана сума от търга достигна 8 900 лева, като всички средства ще бъдат дарени на Детската кардиологична болница.

Събитието не просто съчета спорт и емоции – то изпрати важно послание: когато легенди се обединят за децата, резултатите са реални и значими. Събраните средства ще подпомогнат условията и лечението в единствената специализирана кардиологична болница за деца в България.`,
    date: "2025-08-01",
    location: "Pirin Golf & Country Club, Разлог",
    category: "charity",
    image: golfTournamentGallery[0]?.url || Golf1,
    detail_image: Golf1,
    card_image_position: "center 25%",
    show_ticket_button: false,
    show_calendar_button: false,
    ticket_url: null,
    video_url: null,
    isFeatured: false,
  },
  {
    id: "event_6",
    title: "Eternal glory for Trifon Ivanov: Veliko Tarnovo unveiled a monument to the legendary defender",
    title_bg: "Вечна слава за Трифон Иванов: Велико Търново откри паметник на легендарния защитник",
    description: `On July 27, 2025, the day football legend Trifon Ivanov would have turned 60, Veliko Tarnovo paid a well-deserved tribute to its hero. With a solemn ceremony in front of the Ivailo Stadium, a monument to the "iron" defender was unveiled - a symbol of the unshakable Bulgarian spirit and an era in which football was a national pride.

**The Iron Heart of Bulgaria**

Trifon Ivanov left a deep mark not only on the field, but also in the hearts of millions of Bulgarians. With 76 matches for the national team, a key role in the bronze feat of the USA '94 and an indomitable character, Trifon was and remains a symbol of the true athlete - straightforward, dedicated and always devoted to his homeland.

**A monument erected with love and gratitude**

The monument is made of bronze, over two meters high, and is the work of the Varna sculptor Nikolay Ninov. The statue is placed right in front of the entrance to the Ivailo Stadium – where Trifon Ivanov began his professional football career. The place is not just symbolic – it is part of his personal history and that of Veliko Tarnovo.

The monument was built entirely with public funds – over 70,000 leva, collected within a year through a campaign supported by football greats such as Hristo Stoichkov, Krasimir Balakov and thousands of fans from the country and abroad.

**A ceremonial opening with an eye to the future**

The opening of the monument took place in the presence of hundreds of citizens, representatives of the municipality, the Bulgarian Football Union, the clergy and the sports community. After a requiem prayer, the consecration of the monument and the laying of wreaths, the anthem of the Republic of Bulgaria was played – a gesture reminiscent of the pride that Trifon carried every time he put on the national jersey.

The beginning of an idea for creating an "Alley of Fame", in which other great athletes associated with Veliko Tarnovo would be honored, was also announced.

**Children's Tournament: CSKA triumphs again**

After the ceremony, the final of the children's tournament in memory of Trifon Ivanov was held. The matches were played in a 2×30 minute format, and the winner was the CSKA team, which defeated Ludogorets 5:4 after penalties (1:1 in regular time). This was the fourth consecutive title for the "reds" in this tournament.

Slavia won third place after a convincing victory over Beroe 3:0, and Lokomotiv (Gorna Oryahovitsa) defeated Etar 4:1 in the match for fifth place. The individual "Trifon Ivanov" award was received by Aleksandar Metodiev from CSKA, and the awards were presented by Hristo Stoichkov and Krasimir Balakov.

**Forever among us**

The monument to Trifon Ivanov is not just a sculpture. It is a testament that Veliko Tarnovo and Bulgaria do not forget their heroes. The Iron No. 3 remains forever in the pantheon of Bulgarian sports, as an example of honor, dedication and unconditional love for the homeland.

**"Trifon Ivanov did not leave. He remained forever among us."**`,
    description_bg: `На 27 юли 2025 г., в деня, в който футболната легенда Трифон Иванов щеше да навърши 60 години, Велико Търново отдаде заслужена почит на своя герой. С тържествена церемония пред стадион „Ивайло" бе открит паметник на „железния" защитник – символ на непоклатимия български дух и на една епоха, в която футболът беше национална гордост.

**Желязното сърце на България**

Трифон Иванов остави дълбока следа не само на терена, но и в сърцата на милиони българи. С 76 мача за националния отбор, ключова роля в бронзовия подвиг на САЩ '94 и несломим характер, Трифон беше и си остава символ на истинския спортист – прям, всеотдаен и винаги отдаден на родината си.

**Паметник, издигнат с любов и признателност**

Монументът е изработен от бронз, висок над два метра, и е дело на варненския скулптор Николай Нинов. Статуята е поставена точно пред входа на стадион „Ивайло" – там, където Трифон Иванов започва професионалния си път във футбола. Мястото е не просто символично – то е част от неговата лична история и тази на Велико Търново.

Паметникът бе изграден изцяло с обществени средства – над 70 000 лв., събрани в рамките на една година чрез кампания, подкрепена от футболни величия като Христо Стоичков, Красимир Балъков и хиляди фенове от страната и чужбина.

**Тържествено откриване с поглед към бъдещето**

Откриването на паметника се състоя в присъствието на стотици граждани, представители на общината, БФС, духовенството и спортната общност. След заупокойна молитва, освещаване на монумента и полагане на венци, прозвуча химнът на Република България – жест, напомнящ за гордостта, която Трифон носеше всеки път, когато обличаше националната фланелка.

Обявено бе и началото на идея за създаване на „Алея на славата", в която да бъдат почетени и други велики спортисти, свързани с Велико Търново.

**Детски турнир: ЦСКА триумфира отново**

След церемонията се проведе финалът на детския турнир в памет на Трифон Иванов. Мачовете се играха във формат 2×30 минути, а победител стана отборът на ЦСКА, който победи Лудогорец с 5:4 след дузпи (1:1 в редовното време). Това бе четвърта поредна титла за "червените" в този турнир.

Славия завоюва третото място след убедителна победа над Берое с 3:0, а Локомотив (Горна Оряховица) победи Етър с 4:1 в мача за петото място. Индивидуалната награда "Трифон Иванов" получи Александър Методиев от ЦСКА, а наградите бяха връчени от Христо Стоичков и Красимир Балъков.

**Завинаги сред нас**

Паметникът на Трифон Иванов не е просто скулптура. Той е свидетелство, че Велико Търново и България не забравят своите герои. Железният №3 остава завинаги в пантеона на българския спорт, като пример за чест, себеотдаване и безрезервна любов към родината.

**„Трифон Иванов не си тръгна. Той остана завинаги сред нас."**`,
    date: "2025-07-27",
    location: "Стадион „Ивайло“, Велико Търново",
    category: "",
    image: Pametnik1,
    show_ticket_button: false,
    show_calendar_button: false,
    ticket_url: null,
    video_url: null,
    isFeatured: false,
  },
  {
    id: "event_7",
    title: "112,000 leva were raised to support the families and victims of the fire in Kochani",
    title_bg: "Бяха събрани 112 000 лв. в подкрепа на семействата и пострадалите при пожара в Кочани",
    description: `The charity match between the legends of Bulgaria '94 and the stars of North Macedonia brought the audience together at the Spartak Stadium in Varna in the name of goodness.

The Spartak Stadium in Varna became the scene of an unforgettable event filled with football, emotions and nobility. The legends of Bulgaria '94 and the stars of North Macedonia met in a friendly charity match that turned back time and brought together thousands of fans of the beautiful game, united by the cause of helping the victims of the tragedy in the Macedonian city of Kochani.

The organizer of the event was the Nationals 94 Foundation, established on the occasion of the 30th anniversary of Bulgaria's historic performance at the World Cup in the USA. The initiative aims to support former national athletes and disadvantaged children who practice football. Varna was chosen to host the foundation's first event - a symbolic choice for the new beginning of a cause that unites sport and social responsibility.

**A match – much more than a game**

On the pitch, fans saw favorites from several generations – Hristo Stoichkov, Krasimir Balakov, Yordan Lechkov, Borislav Mihaylov, Nasko Sirakov, as well as younger stars like Martin Kamburov, Valeri Bozhinov and Elin Topuzakov. On the other side – the legends of North Macedonia, led by Goran Pandev and Gjoko Hadzhievski, also demonstrated class, emotion and respect.

The match began with a minute of silence in memory of the victims of the fire in Kochani, which claimed the lives of 61 people and injured over 150. The players took to the pitch not only because of their passion for football, but also to support the victims and their families.

The spectacle on the pitch was accompanied by a real unity in the stands. Over 8,000 spectators applauded every good moment, while charity auctions and fundraising campaigns were held in the meantime. The total amount of 112,000 leva will be used to support the families affected by the tragedy in Kochani.

"This was much more than a football match - it was a demonstration of humanity and solidarity between neighboring nations," said Hristo Stoichkov after the match, who contributed several beautiful goals to the spectacle of the event.`,
    description_bg: `Благотворителният мач между легендите от България '94 и звездите от Северна Македония събра публиката на стадион „Спартак" във Варна в името на доброто.

Стадион „Спартак" във Варна стана сцена на едно незабравимо събитие, изпълнено с футбол, емоции и благородство. Легендите от България '94 и звездите на Северна Македония се срещнаха в приятелски благотворителен мач, който върна времето назад и събра хиляди почитатели на красивата игра, обединени от каузата да помогнат на пострадалите от трагедията в македонския град Кочани.

Организатор на събитието бе Фондация „Национали 94", създадена по повод 30-годишнината от историческото представяне на България на Световното първенство в САЩ. Инициативата има за цел да подпомага бивши национални състезатели и деца в неравностойно положение, които тренират футбол. Варна бе избрана за домакин на първото събитие на фондацията – символичен избор за новото начало на кауза, която обединява спорт и социална отговорност.

**Един мач – много повече от игра**

На терена феновете видяха любимци от няколко поколения – Христо Стоичков, Красимир Балъков, Йордан Лечков, Борислав Михайлов, Наско Сираков, както и по-млади звезди като Мартин Камбуров, Валери Божинов и Елин Топузаков. От другата страна – легендите на Северна Македония, водени от Горан Пандев и Гьоко Хаджиевски, също демонстрираха класа, емоция и уважение.

Мачът започна с едноминутно мълчание в памет на жертвите от пожара в Кочани, който отне живота на 61 души и рани над 150. Играчите излязоха на терена не само заради футболната страст, но и за да подкрепят пострадалите и техните семейства.

Зрелището на терена беше придружено от истинско обединение на трибините. Над 8000 зрители аплодираха всеки добър момент, а междувременно се провеждаха благотворителни търгове и кампании за набиране на средства. Общата сума от 112 000 лева ще бъде използвана за подпомагане на пострадалите семейства от трагедията в Кочани.

„Това беше много повече от футболен мач - беше демонстрация на човечност и солидарност между съседните народи", заяви след срещата Христо Стоичков, който допринесе с няколко красиви гола за зрелищността на събитието.`,
    date: "2025-04-27",
    location: `Стадион „Спартак", Варна`,
    category: "charity",
    image: Varna11,
    images: kochaniCharityGallery.slice(0, 4).map(img => img.url),  // ТОВА Е НОВОТО
    image: kochaniCharityGallery[0]?.url,  // Първата снимка за корица
    show_ticket_button: false,
    show_calendar_button: false,
    ticket_url: null,
    video_url: null,
    isFeatured: false,
  },
  {
    id: "event_8",
    title: `MARINELA - The Heroes of USA'94 raised nearly 460,000 leva in support of the "Nationals 94" Foundation`,
    title_bg: `МАРИНЕЛА - Героите от САЩ'94 събраха близо 460 000 лева в подкрепа на фондация „Национали 94`,
    description: `An evening filled with emotions, memories and generosity raised nearly 460,000 leva in support of the Nationals 94 Foundation, founded by the legendary Bulgarian football team that won the bronze medals at the 1994 World Cup in the USA. The event was held at the capital's Marinela Hotel and brought together almost all of the heroic members of the Penevata Cheta, with the exception of Emil Kremenliev and Iliyan Kiryakov, who had urgent commitments, as well as Petar Hubchev, who was battling a serious illness. The memory of Trifon Ivanov was also specially honored.

The evening passed with a high dose of nostalgia and sportsmanship, and the main highlight was the charity auction of original items from the World Cup. Only from the envelopes, ranging between 1,000 and 1,500 leva, and donations, 67,100 leva were collected. However, the amount quickly increased by another 391,000 leva at the auction thanks to the active participation of representatives of the business elite, who spared no expense in acquiring unique relics from that unforgettable American summer.

The highest-valued were two Hristo Stoichkov jerseys – one in which he scored two goals against Greece in Bulgaria’s first historic victory at a World Cup, and the other from the match against Argentina, when he scored again. Both were sold for 100,000 leva each – one was bought by Slavi Binev, and the other by Professor Nikolay Valchanov. Stoichkov’s shoes from the same match with Greece reached a price of 60,000 leva and were purchased by businessman Vladimir Zhitenski. Krasimir Balakov's jerseys also attracted interest - the red one was sold for 15,000 leva, and the white one for 10,000.

The other items were no less impressive - an original ball from USA'94 with the autographs of the entire squad was acquired by Todor Batkov for 20,000 leva, which he donated to the Levski museum. Yordan Lechkov's shoes from the match with Mexico reached 10,000 leva, and his jersey was purchased by Sofia Mayor Vasil Terziev for 7,000 leva. The current general sponsor of Levski, Milo Borisov, paid 12,000 leva for Daniel Borimirov's shoes and another 10,000 for a special silver coin donated by Nasko Sirakov. Both the team of the reserve goalkeeper Plamen Nikolov and a special plaque with photos of all the national teams, provided by Krasimir Borisov, were sold for 5,000 leva. The shoes of the youngest participant in the football fairy tale – Velko Yotov – also reached a price of 10,000 leva.

The event was not just about buying and bidding. Hristo Stoichkov gave all his teammates and coaches a special painting dedicated to Bulgaria’s first victory in a world football final. Vladimir Zhitenski announced that all the items he purchased would be donated to the future museum of Hristo Stoichkov, because, in his words, these are national treasures that should be accessible to everyone. A similar position was expressed by Prof. Valchanov, who revealed that he owns a personal museum dedicated to the most successful football player in the history of Bulgaria, but will also donate his collection to the “Hall of Fame – Hristo Stoichkov”.

There is great optimism about the initiative - according to Professor Valchanov, the "Nationals 94" Foundation can raise about one million leva by the end of the year. After this strong start, however, this goal seems closer than ever.`,
    description_bg: `Една вечер, изпълнена с емоции, спомени и щедрост, събра близо 460 000 лева в подкрепа на фондация „Национали 94", основана от легендарния български футболен отбор, завоювал бронзовите медали на Световното първенство в САЩ през 1994 година. Събитието се проведе в столичния хотел „Маринела" и събра почти всички от героичния състав на Пеневата чета, с изключение на Емил Кременлиев и Илиян Киряков, които имаха неотложни ангажименти, както и на борещия се с тежко заболяване Петър Хубчев. Специално бе почетена и паметта на Трифон Иванов.

Вечерта премина с висока доза носталгия и спортен дух, а основен акцент бе благотворителният търг на оригинални артикули от Мондиала. Само от кувертите, вариращи между 1000 и 1500 лева, и даренията бяха събрани 67 100 лева. В търга обаче сумата бързо нарасна с още 391 000 лева благодарение на активното участие на представители на бизнес елита, които не пожалиха средства, за да се сдобият с уникални реликви от онова незабравимо американско лято.

Най-високо бяха оценени две фланелки на Христо Стоичков – едната, с която отбеляза два гола срещу Гърция в първата историческа победа на България на световно първенство, и другата от мача срещу Аржентина, когато отново се разписа. И двете бяха продадени за по 100 000 лева – едната бе купена от Слави Бинев, а другата от професор Николай Вълчанов. Обувките на Стоичков от същия мач с Гърция достигнаха цена от 60 000 лева и бяха закупени от бизнесмена Владимир Житенски. Фланелките на Красимир Балъков също предизвикаха интерес – червената бе продадена за 15 000 лева, а бялата – за 10 000.

Не по-малко впечатляващи бяха и останалите артикули – оригинална топка от САЩ'94 с автографите на целия състав бе придобита от Тодор Батков за 20 000 лева, като той я дарява на музея на „Левски". Обувките на Йордан Лечков от мача с Мексико достигнаха 10 000 лева, а неговата фланелка бе закупена от кмета на София Васил Терзиев за 7000 лева. Настоящият генерален спонсор на „Левски" Мило Борисов плати 12 000 лева за обувките на Даниел Боримиров и още 10 000 за специална сребърна монета, дарена от Наско Сираков. За 5000 лева бяха продадени както екипът на резервния вратар Пламен Николов, така и специален плакет със снимки на всички национали, предоставен от Красимир Борисов. Обувките на най-младия участник във футболната приказка – Велко Йотов – също достигнаха цена от 10 000 лева.

Събитието не беше само за купуване и наддаване. Христо Стоичков подари на всичките си съотборници и треньори специална картина, посветена на първата победа на България на световни футболни финали. Владимир Житенски обяви, че всички закупени от него предмети ще бъдат дарени на бъдещия музей на Христо Стоичков, защото, по думите му, това са национални богатства, които трябва да бъдат достъпни за всички. Подобна позиция изрази и проф. Вълчанов, който разкри, че притежава личен музей, посветен на най-успешния футболист в историята на България, но също ще предаде своята колекция на „Залата на Славата – Христо Стоичков".

Оптимизмът около инициативата е голям – според професор Вълчанов фондация „Национали 94" може да събере около един милион лева още до края на годината. След този силен старт обаче, тази цел изглежда по-близка от всякога.`,
    date: "2024-07-17",
    location: `Хотел „Маринела", София`,
    category: "charity",
    image: Marinela1,
    images: legendsEveningGallery.slice(0, 4).map(img => img.url),
    image: legendsEveningGallery[0]?.url,
    show_ticket_button: false,
    show_calendar_button: false,
    ticket_url: null,
    video_url: null,
    isFeatured: false,
  },












  // Моментни събития (за началната страница)
//  {
  //  id: "event_10",
  //  title: "",
  //  title_bg: "",
   // description: ``,
  
   // description_bg: ``,
   // date: "",
   // location: ``,
  //  category: "new",
  //  image: Moment1,
   // isFeatured: true,

  //},
  {
    id: "event_9",
    title: "We donated €40,000 in support of the 'Match of Hope'",
    title_bg: "Дарихме 40 000 евро в подкрепа на „Мач на надеждата“",
    description: `The Nationals 94 Foundation joined the charity initiative "Match of Hope", organized by the Stiliyan Petrov Foundation at Lazur Stadium in Burgas.

Before the start of the match, Zlatko Yankov presented, on behalf of the Nationals 94 Foundation, a donation check worth €40,000 in support of the cause.

The event brought together thousands of spectators and some of the biggest names in Bulgarian and world football, united by the common mission to support people in the fight against cancer.

Part of the funds raised during the initiative will be directed to the Complex Oncology Center in Burgas, as well as in support of our friends, teammates and members of the Nationals 94 Foundation – Petar Hubchev and Lyuboslav Penev.

In the match itself, the World Stars team defeated the Bulgarian Stars team 4:3 in a true football spectacle, full of emotions, beautiful goals and many smiles. The result, however, remained in the background, because the big winner was the cause.

We thank Stiliyan Petrov and his team for organizing this wonderful event. Together we prove that when we are united, we can give hope, strength and real help.

Together we are stronger!`,
    description_bg: `Фондация „Национали 94“ се включи в благотворителната инициатива „Мач на надеждата“, организирана от Фондация „Стилиян Петров“ на стадион „Лазур“ в Бургас.

Преди началото на двубоя Златко Янков връчи от името на Фондация „Национали 94“ дарителски чек на стойност 40 000 евро в подкрепа на каузата.

Събитието събра хиляди зрители и едни от най-големите имена в българския и световния футбол, обединени от общата мисия да подкрепят хората в борбата с онкологичните заболявания.

Част от средствата, събрани по време на инициативата, ще бъдат насочени към Комплексния онкологичен център в Бургас, както и в подкрепа на нашите приятели, съотборници и членове на Фондация „Национали 94“ – Петър Хубчев и Любослав Пенев.

В самия двубой отборът на световните звезди победи звездния тим на България с 4:3 в истински футболен спектакъл, изпълнен с емоции, красиви попадения и много усмивки. Резултатът обаче остана на заден план, защото големият победител беше каузата.

Благодарим на Стилиян Петров и неговия екип за организацията на това прекрасно събитие. Заедно доказваме, че когато сме обединени, можем да даваме надежда, сила и реална помощ.

Заедно сме по-силни!`,
    date: "2026-06-06",
    location: "Burgas Lazur Stadium",
    category: "featured",
    images: hopeMatchGallery.slice(0, 4).map(img => img.url),  
    image: hopeMatchGallery[0]?.url,
    isFeatured: true,
    show_ticket_button: true,
    ticket_url: "https://shorturl.at/6priP",
  },



];










export const teamMembers = [
  // =================
  // STARTING XI (ТИТУЛЯРИ)
  // =================
  // Вратар
  {
    id: "player_1",
    name: "Borislav Mihaylov",
    name_bg: "Борислав Михайлов",
    position: "Goalkeeper",
    position_bg: "Вратар",
    bio: "Legendary goalkeeper and captain of the 1994 World Cup team that reached the semi-finals.",
    bio_bg: "Легендарен вратар и капитан на отбора от Световното през 1994, достигнал полуфинал.",
    image: BobiM1,
    number: 1
  },
  // Защитници
  {
    id: "player_7",
    name: "Tsanko Tsvetanov",
    name_bg: "Цанко Цветанов",
    position: "Defender",
    position_bg: "Защитник",
    bio: "Versatile defender who started as right back for Bulgaria at the 1994 World Cup.",
    bio_bg: "Универсален защитник, който започна като десен бек за България на Световното през 1994.",
    image: CankoC,
    number: 4
  },
  {
    id: "player_6",
    name: "Petar Hubchev",
    name_bg: "Петър Хубчев",
    position: "Defender",
    position_bg: "Защитник",
    bio: "Solid central defender who formed an impenetrable partnership with Trifon Ivanov.",
    bio_bg: "Солиден централен защитник, който създаде непробиваем дует с Трифон Иванов.",
    image: PeturH,
    number: 5
  },
  {
    id: "player_3",
    name: "Trifon Ivanov",
    name_bg: "Трифон Иванов",
    position: "Defender",
    position_bg: "Защитник",
    bio: "The Wolf - legendary central defender known for his aggressive style and heading ability.",
    bio_bg: "Вълка - легендарен централен защитник, известен с агресивния си стил и игра с глава.",
    image: TrifonI,
    number: 3
  },
  {
    id: "player_5",
    name: "Emil Kremenliev",
    name_bg: "Емил Кременлиев",
    position: "Defender",
    position_bg: "Защитник",
    bio: "Defender who started the group match against Greece at the 1994 World Cup.",
    bio_bg: "Защитник, който започна като титуляр груповия мач срещу Гърция на Световното през 1994.",
    image: EmilR,
    number: 2,
  },
  // Полузащитници
  {
    id: "player_16",
    name: "Nasko Sirakov",
    name_bg: "Наско Сираков",
    position: "Forward",
    position_bg: "Нападател",
    bio: "Experienced forward who scored against Greece in the group stage of the 1994 World Cup.",
    bio_bg: "Опитен нападател, който отбеляза гол срещу Гърция в груповата фаза на Световното през 1994.",
    image: NaskoS,
    number: 10
  },
  {
    id: "player_13",
    name: "Zlatko Yankov",
    name_bg: "Златко Янков",
    position: "Midfielder",
    position_bg: "Халф",
    bio: "Defensive midfielder and the backbone of the team's defensive organization.",
    bio_bg: "Дефанзивен халф и гръбнакът на защитната организация на отбора.",
    image: ZlatkoY,
    number: 6
  },
  {
    id: "player_11",
    name: "Krasimir Balakov",
    name_bg: "Красимир Балъков",
    position: "Midfielder",
    position_bg: "Халф",
    bio: "Creative playmaker and the engine of the team with exceptional passing and vision.",
    bio_bg: "Креативен плеймейкър и двигателят на отбора с изключително подаване и визия.",
    image: KrasiB1,
    number: 20
  },
  {
    id: "player_10",
    name: "Yordan Letchkov",
    name_bg: "Йордан Лечков",
    position: "Midfielder",
    position_bg: "Халф",
    bio: "Scored the iconic header against Germany in the quarter-final of the 1994 World Cup.",
    bio_bg: "Вкара емблематичния гол с глава срещу Германия на четвъртфинала на Световното през 1994.",
    image: YordanL,
    number: 9
  },

  // Нападатели
  {
    id: "player_15",
    name: "Hristo Stoichkov",
    name_bg: "Христо Стоичков",
    position: "Forward",
    position_bg: "Нападател",
    bio: "The Golden Left Foot. Top scorer of the 1994 World Cup with 6 goals, winner of the Golden Boot.",
    bio_bg: "Златното ляво краче. Голмайстор на Световното през 1994 с 6 гола, носител на Златната обувка.",
    image: HristoS1,
    number: 8
  },
  {
    id: "player_17",
    name: "Emil Kostadinov",
    name_bg: "Емил Костадинов",
    position: "Forward",
    position_bg: "Нападател",
    bio: "Hero of the qualification against France with two goals in Paris. Started alongside Stoichkov.",
    bio_bg: "Героят от квалификацията срещу Франция с два гола в Париж. Играеше в атака заедно със Стоичков.",
    image: EmilK,
    number: 7
  },

  // =================
  // RESERVES (РЕЗЕРВИ)
  // =================
  {
    id: "player_2",
    name: "Plamen Nikolov",
    name_bg: "Пламен Николов",
    position: "Goalkeeper",
    position_bg: "Вратар",
    bio: "Reserve goalkeeper who was part of the 1994 World Cup squad.",
    bio_bg: "Резервен вратар, който беше част от състава за Световното през 1994.",
    image: PlamenN1,
    number: 12,
    is_reserve: true
  },
  {
    id: "player_4",
    name: "Ilian Kiriakov",
    name_bg: "Илиан Киряков",
    position: "Defender",
    position_bg: "Защитник",
    bio: "Left back known for his crosses and defensive stability, starter at the 1994 World Cup.",
    bio_bg: "Ляв бек, известен с центриранията си и стабилност в защита, титуляр на Световното през 1994.",
    image: IlianK,
    number: 16,
    is_reserve: true
  },
  {
    id: "player_8",
    name: "Nikolai Iliev",
    name_bg: "Николай Илиев",
    position: "Defender",
    position_bg: "Защитник",
    bio: "Defender who provided cover in the defensive line during the 1994 World Cup.",
    bio_bg: "Защитник, който осигуряваше резерва в защитната линия по време на Световното през 1994.",
    image: NikolaiI,
    number: 15,
    is_reserve: true
  },
  {
    id: "player_9",
    name: "Ivaylo Andonov",
    name_bg: "Ивайло Андонов",
    position: "Defender",
    position_bg: "Защитник",
    bio: "Reliable right back who was part of Bulgaria's 1994 World Cup squad.",
    bio_bg: "Надежден десен бек, който беше част от състава на България за Световното през 1994.",
    image: IvayloA,
    number: 22,
    is_reserve: true
  },
  {
    id: "player_12",
    name: "Daniel Borimirov",
    name_bg: "Даниел Боримиров",
    position: "Midfielder",
    position_bg: "Халф",
    bio: "Versatile midfielder who came on as a substitute in several matches including the semi-final.",
    bio_bg: "Универсален халф, който влизаше като резерва в няколко мача, включително полуфинала.",
    image: DanielB,
    number: 11,
    is_reserve: true
  },
  {
    id: "player_14",
    name: "Georgi Georgiev",
    name_bg: "Георги Георгиев",
    position: "Midfielder",
    position_bg: "Халф",
    bio: "Midfielder who provided depth in the midfield during the 1994 World Cup.",
    bio_bg: "Халф, който осигуряваше дълбочина в полузащитата по време на Световното през 1994.",
    image: GeorgiI,
    number: 19,
    is_reserve: true
  },
  {
    id: "player_18",
    name: "Ivaylo Yordanov",
    name_bg: "Ивайло Йорданов",
    position: "Forward",
    position_bg: "Нападател",
    bio: "Dynamic right winger who started several matches including the semi-final against Italy.",
    bio_bg: "Динамично дясно крило, което започна като титуляр в няколко мача, включително полуфинала срещу Италия.",
    image: IvayloY,
    number: 13,
    is_reserve: true
  },
  {
    id: "player_19",
    name: "Boncho Genchev",
    name_bg: "Бончо Генчев",
    position: "Forward",
    position_bg: "Нападател",
    bio: "Forward who was part of Bulgaria's 1994 World Cup squad.",
    bio_bg: "Нападател, който беше част от състава на България за Световното през 1994.",
    image: BonchoG,
    number: 14,
    is_reserve: true
  },
  {
    id: "player_21",
    name: "Petar Aleksandrov",
    name_bg: "Петър Александров",
    position: "Forward",
    position_bg: "Нападател",
    bio: "Forward who was part of the 1994 World Cup squad.",
    bio_bg: "Нападател, който беше част от състава за Световното през 1994.",
    image: PetarA,
    number: 18,
    is_reserve: true
  },
  {
    id: "player_20",
    name: "Petar Mihtarski",
    name_bg: "Петър Михтарски",
    position: "Forward",
    position_bg: "Нападател",
    bio: "Forward who represented Bulgaria at the 1994 World Cup. Played for Levski Sofia and CSKA Sofia.",
    bio_bg: "Нападател, който представя България на Световното през 1994. Играл е за Левски София и ЦСКА София.",
    image: PetarM,
    number: 17,
    is_reserve: true
  },
  {
    id: "player_22",
    name: "Velko Yotov",
    name_bg: "Велко Йотов",
    position: "Forward",
    position_bg: "Нападател",
    bio: "Forward who was part of the expanded squad for the 1994 World Cup.",
    bio_bg: "Нападател, който беше част от разширения състав за Световното през 1994.",
    image: VelkoY,
    number: 21,
    is_reserve: true
  }
];




// Coaches
export const coaches = [
  {
    id: "coach_1",
    name: "Dimitar Penev",
    name_bg: "Димитър Пенев",
    position: "Head Coach",
    position_bg: "Старши треньор",
    bio: "The legendary coach who led Bulgaria to 4th place at the 1994 World Cup.",
    bio_bg: "Легендарният треньор, който изведе България до 4-то място на Световното първенство през 1994 г.",
    image: DimitarPenev
  },
  {
    id: "coach_2",
    name: "Krasimir Borisov",
    name_bg: "Красимир Борисов",
    position: "Assistant Coach",
    position_bg: "Помощник треньор",
    bio: "Assistant coach, part of the legendary 1994 coaching staff.",
    bio_bg: "Помощник треньор, част от легендарния щаб от 1994 г.",
    image: KrasimirB
  }
];

// Board Members
export const boardMembers = [
  {
    id: "board_0",
    name: "Borislav Mihaylov",
    name_bg: "Борислав Михайлов",
    position: "Founder",
    position_bg: "Основател",
    bio: "Founder and representative of the Nationals 94 Foundation.",
    bio_bg: "Основател и представител на Фондация „Национали 94“.",
    image: BobiM,
    memorial: true
  },
  {
    id: "board_1",
    name: "Plamen Nikolov",
    name_bg: "Пламен Николов",
    position: "National Coordinator",
    position_bg: "Национален координатор",
    bio: "National Coordinator of the Nationals 94 Foundation.",
    bio_bg: "Национален координатор на Фондация „Национали 94“.",
    image: PlamenN
  },
  {
    id: "board_2",
    name: "Hristo Stoichkov",
    name_bg: "Христо Стоичков",
    position: "Deputy Chairman",
    position_bg: "Заместник-председател",
    bio: "Deputy Chairman supporting the foundation's development.",
    bio_bg: "Заместник-председател, подпомагащ развитието на фондацията.",
    image: HristoS
  },
  {
    id: "board_3",
    name: "Krasimir Balakov",
    name_bg: "Красимир Балъков",
    position: "Member of the Board of Directors",
    position_bg: "Член на управителния съвет",
    bio: "Contributes to the strategic decisions of the foundation.",
    bio_bg: "Допринася за стратегическите решения на фондацията.",
    image: KrasiB
  },
  {
    id: "board_4",
    name: "Vencislav Rangelov",
    name_bg: "Венцислав Рангелов",
    position: "Chairman of the Supervisory Board",
    position_bg: "Председател на контролния съвет",
    bio: "Oversees the financial accountability and legal compliance of the foundation.",
    bio_bg: "Отговаря за финансовото отчетност и законовото съответствие на фондацията.",
    image: VenciR
  },
  {
    id: "board_5",
    name: "Vladimir Pamukov",
    name_bg: "Владимир Памуков",
    position: "Supervisory Board - Journalist",
    position_bg: "Контролен съвет - Журналист",
    bio: "Journalist ensuring transparency and public communication.",
    bio_bg: "Журналист, осигуряващ прозрачност и публична комуникация.",
    image: VladiP
  },
  {
    id: "board_6",
    name: "Mincho Arbov",
    name_bg: "Минчо Арбов",
    position: "Supervisory Board - Lawyer",
    position_bg: "Контролен съвет - Адвокат",
    bio: "Lawyer providing legal counsel and ensuring statutory compliance.",
    bio_bg: "Адвокат предоставящ правни консултации и гарантиращ законовото съответствие.",
    image: MinchoA
  },
  {
    id: "board_7",
    name: "Stanislav Rezashki",
    name_bg: "Станислав Резашки",
    position: "Supervisory Board - Accountant",
    position_bg: "Контролен съвет - Счетоводител",
    bio: "Accountant managing the foundation's financial records and audits.",
    bio_bg: "Счетоводител управляващ финансовото счетоводство и одитите на фондацията.",
    image: StanislavR
  },
];

// Statistics
export const stats = {
  youth_players: 1500,
  annual_events: 12,
  funds_raised: 250000,
  years_active: 30
};

// ========== ПРОДУКТИ ЗА МАГАЗИНА ==========

// Продуктите са временно премахнати поради липса на снимки
// За да добавите продукти, следвайте този модел:

/*
export const products = [
  {
    id: 1,
    name: "Bulgaria 94 Retro Jersey",
    name_bg: "Ретро екип България 94",
    description: "Authentic retro jersey from the legendary 1994 World Cup team",
    description_bg: "Автентичен ретро екип от легендарния отбор на Световното през 1994",
    price: 89.99,
    image: "/images/products/jersey.webp"  // Път до снимката
  },
  // ... още продукти
];
*/

// Временни продукти за тестване (без снимки)
export const products = [
  {
    id: 1,
    name: `Nationals 94 Charity Towel`,
    name_bg: `Благотворителна кърпа „Национали 94“`,
    description: "A towel with the embroidered logo of the Nationals 94 Foundation. 100% of the proceeds from each purchase are donated to the cause of the nearest upcoming Foundation event.",
    description_bg: "Кърпа с бродирано лого на Фондация „Национали 94“. 100% от средствата от покупката се даряват за каузата на най-близкото предстоящо събитие на Фондацията.",
    price: 30,
    image: Shop1,
    images: [Shop1, towelFolded, towelDetail],
    maxQuantity: 10,
  },
  /*{
    id: 2,
    name: "Sample Product 2",
    name_bg: "Примерен продукт 2",
    description: "This is a sample product description",
    description_bg: "Това е примерно описание на продукт",
    price: 79.99,
    image: "https://via.placeholder.com/400x400?text=Product+2"
  },
  {
    id: 3,
    name: "Sample Product 3",
    name_bg: "Примерен продукт 3",
    description: "This is a sample product description",
    description_bg: "Това е примерно описание на продукт",
    price: 99.99,
    image: "https://via.placeholder.com/400x400?text=Product+3"
  }*/
];

// ========== КОЛИЧКА ФУНКЦИИ ==========

const notifyCartUpdated = () => {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('cartUpdated'));
  }
};

export const getCart = () => {
  const cart = localStorage.getItem('cart');
  return cart ? JSON.parse(cart).map(item => {
    const product = products.find(product => product.id === item.id);
    return product ? { ...item, image: product.image, images: product.images } : item;
  }) : [];
};

export const addToCart = (product, quantity = 1) => {
  const cart = getCart();
  const existingIndex = cart.findIndex(item => item.id === product.id);
  
  if (existingIndex >= 0) {
    cart[existingIndex].quantity = Math.min(product.maxQuantity || 10, cart[existingIndex].quantity + quantity);
  } else {
    cart.push({ ...product, quantity: Math.min(product.maxQuantity || 10, Math.max(1, quantity)) });
  }
  
  localStorage.setItem('cart', JSON.stringify(cart));
  notifyCartUpdated();
  return cart;
};

export const removeFromCart = (productId) => {
  const cart = getCart().filter(item => item.id !== productId);
  localStorage.setItem('cart', JSON.stringify(cart));
  notifyCartUpdated();
  return cart;
};

export const updateCartQuantity = (productId, quantity) => {
  const cart = getCart();
  const index = cart.findIndex(item => item.id === productId);
  
  if (index >= 0) {
    if (quantity <= 0) {
      cart.splice(index, 1);
    } else {
      cart[index].quantity = Math.min(cart[index].maxQuantity || 10, quantity);
    }
  }
  
  localStorage.setItem('cart', JSON.stringify(cart));
  notifyCartUpdated();
  return cart;
};

export const clearCart = () => {
  localStorage.removeItem('cart');
  notifyCartUpdated();
  return [];
};

export const getCartTotal = () => {
  return getCart().reduce((sum, item) => sum + (item.price * item.quantity), 0);
};
